(ns ui.view.entity-creator.model)

(def root ::state)
(def root-path [root])

;; Multiple simultaneous creator-modals allowed
;; => each instance must have an identity.
;; In this case
;; identity will be a vector that, combined with
;; the root key above denotes the path where in the rf-state
;; the modal instance related state will be located
(defn i-root
  [ident]
  {:pre [(vector? ident)]}
  (into root-path ident))

(def entity-type-key :entity-type)
(def entity-type-path [entity-type-key])
(defn entity-type-full-path
  [ident]
  (into (i-root ident) entity-type-path))

(def pipeline-key :pipeline)
(def pipeline-path [pipeline-key])
(defn pipeline-full-path
  [ident]
  (into (i-root ident) pipeline-path))

(def stage-key :stage)
(def stage-path [stage-key])
(defn stage-full-path
  [ident]
  (into (i-root ident) stage-path))

(def processing-key :processing)
(def processing-path [processing-key])
(defn processing-full-path
  [ident]
  (into (i-root ident) processing-path))

(def processing-start-time-key :processing-start-time)
(def processing-start-time-path [processing-start-time-key])
(defn processing-start-time-full-path
  [ident]
  (into (i-root ident) processing-start-time-path))

(def created-entity-key :created-entity)
(def created-entity-path [created-entity-key])
(defn created-entity-full-path
  [ident]
  (into (i-root ident) created-entity-path))

(def callbacks-key :callbacks)
(def callbacks-path [callbacks-key])
(defn callbacks-full-path
  [ident]
  (into (i-root ident) callbacks-path))

(def edits-key :edits)
(def edits-path [edits-key])
(defn edits-full-path
  [ident]
  (into (i-root ident) edits-path))

(def entity-edits-key :entity)
(def entity-edits-path [entity-edits-key])
(defn entity-edits-full-path
  [ident]
  (into (edits-full-path ident) entity-edits-path))

;;; Effects
(def callback-fx ::callback-fx)

;;; Coeffects
(def pipeline-stages-cofx ::pipeline-stages-cofx)

;;; Subscriptions
(def root-state ::state)
(def state ::state-instance)
(def title ::title)
(def entity-type ::entity-type)
(def system-mandatory ::system-mandatory)
(def field-schemas ::field-schemas)
(def pipeline ::pipeline)
(def stage ::stage)
;; Sorted list of stages for the resolved pipeline (used to resolve per-stage
;; field-config in `m/config`).
(def stages ::stages)
(def edits ::edits)
(def entity-edits ::entity-edits)
;; edits for an entity based on param :entity-edits-path
(def custom-edits ::custom-edits)
(def edited-value ::edited-value)

;; validations:
(def field-errors ::field-errors)
(def entity-validations ::entity-validations)

;; config
(def raw-config ::raw-config)
(def config ::config)
(def config-fields ::config-fields)

(def subview ::subview)

(def processing? ::processing?)
(def created-entity ::created-entity)

;;; Events
(def open-creator ::open-creator)
(def close-creator ::close-creator)
;; editor:
(def edit-value ::edit-value)
;; for setting up a single instance of (non-modal) creator:
(def initialize ::initialize)
;; for cleaning up a single instance of creator:
(def clear-state ::clear-state)

;; :entity/create-entity backend request
(def start-create ::start-create)
(def create-success ::create-success)
(def create-error ::create-error)

(def processing-done ::processing-done)
(def finish ::finish)
